module.exports = __webpack_public_path__ + "img/2F3747_6A7C9E_54637F_62748B-256px.f8fc6ff9.png";